import API from "./baseApi";

// Control Plane operator endpoints (pl-server src/control-plane/control-plane.controller.ts).
// Header versioning defaults to v1, so URLs carry no /v1/ prefix. The tenant is
// sent as x-tenant-id (same as every other pl-crm admin call). GET/retry send no
// body, so baseApi's request-encryption is not triggered.

const getDrift = (tenantId) => {
  API.defaults.headers.common["x-tenant-id"] = tenantId;
  return API.get(`/control-plane/drift`);
};

const getCustomerServices = (tenantId, customerId) => {
  API.defaults.headers.common["x-tenant-id"] = tenantId;
  return API.get(`/control-plane/customer/${customerId}/services`);
};

const retryService = (tenantId, customerId, slug) => {
  API.defaults.headers.common["x-tenant-id"] = tenantId;
  return API.post(`/control-plane/customer/${customerId}/services/${slug}/retry`);
};

// Admin renewal / plan change (spec 003). No payment — extends or changes a plan
// and returns reconciliationNeeded + overLimitFields on a downgrade.
const adminRenew = (tenantId, customerId, targetProgramId) => {
  API.defaults.headers.common["x-tenant-id"] = tenantId;
  const body = { tenant: tenantId, customerId };
  if (targetProgramId) body.targetProgramId = targetProgramId;
  return API.post(`/cyberior/admin/renew`, body);
};

export default { getDrift, getCustomerServices, retryService, adminRenew };
